import { render, staticRenderFns } from "./log-error.vue?vue&type=template&id=0fbd6155&"
import script from "./log-error.vue?vue&type=script&lang=js&"
export * from "./log-error.vue?vue&type=script&lang=js&"
import style0 from "./log-error.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports